// Summary stat cards component
import React from "react";
import { FiLink, FiMousePointer, FiActivity, FiTrendingUp } from "react-icons/fi";
import "../styles/StatCards.css";

export default function StatCards({ summary }) {
  const cards = [
    {
      label: "Total Links",
      value: summary.total_links || 0,
      icon: <FiLink />,
      color: "#4f46e5",
    },
    {
      label: "Active Links",
      value: summary.active_links || 0,
      icon: <FiActivity />,
      color: "#059669",
    },
    {
      label: "Total Clicks",
      value: summary.total_clicks || 0,
      icon: <FiMousePointer />,
      color: "#d97706",
    },
    {
      label: "Clicks (24h)",
      value: summary.clicks_last_24h || 0,
      icon: <FiTrendingUp />,
      color: "#dc2626",
    },
  ];

  return (
    <div className="stat-cards">
      {cards.map((card) => (
        <div key={card.label} className="stat-card">
          <div className="stat-icon" style={{ color: card.color }}>
            {card.icon}
          </div>
          <div className="stat-info">
            <div className="stat-value">{card.value.toLocaleString()}</div>
            <div className="stat-label">{card.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
